import React, { useState } from "react";

// MATERIAL UI
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
// ICONS
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";

function DebouncedTextField({
  onSearch,
  fullWidth = false,
  placeHolder = "Pesquisar...",
}) {
  const [searchText, setSearchText] = useState("");
  const [typingTimeout, setTypingTimeout] = useState(null);

  const handleInputChange = (event) => {
    const text = event.target.value;
    setSearchText(text);

    // Clear any existing timeout
    clearTimeout(typingTimeout);

    // Set a new timeout to wait for the user to stop typing
    setTypingTimeout(
      setTimeout(() => {
        onSearch(text);
      }, 500)
    ); // Adjust the delay as needed
  };

  const handleClearClick = () => {
    setSearchText("");
    clearTimeout(typingTimeout);
    onSearch(""); // Clear the search results
  };

  return (
    <Box display="flex" justifyContent="center">
      <TextField
        value={searchText}
        onChange={handleInputChange}
        placeholder={placeHolder}
        fullWidth={fullWidth}
        size="small"
        InputProps={{
          startAdornment: (
            <Box display="flex" alignItems="center" mr={1}>
              <SearchIcon color={"info"} />
            </Box>
          ),
          endAdornment: searchText && (
            <IconButton onClick={handleClearClick}>
              <ClearIcon />
            </IconButton>
          ),
        }}
      />
    </Box>
  );
}

export default DebouncedTextField;
